"use client";

import { Button } from "design-system/button";
import { useDescopeLogout } from "@/lib/integrations/descope";

export function ButtonGrouping({
  includeLogoutButton = false,
  includeRefreshButton = false,
  logoutButtonText = "Try Logging Out",
  refreshButtonText = "Try Refreshing",
}: {
  includeLogoutButton?: boolean;
  includeRefreshButton?: boolean;
  logoutButtonText?: string;
  refreshButtonText?: string;
}) {
  const { goToLogoutPage } = useDescopeLogout();

  return (
    <div className="mt-8 flex w-full flex-col gap-5 text-center">
      {includeRefreshButton && (
        <div>
          <Button onClick={() => window.location.assign(window.location.origin)}>{refreshButtonText}</Button>
        </div>
      )}

      {includeLogoutButton && (
        <div>
          <Button onClick={goToLogoutPage} variant="outline">
            {logoutButtonText}
          </Button>
        </div>
      )}
    </div>
  );
}
